import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { FilterBar, FilterSelect, SearchInput } from "@/components/ReportTable";

const SHEET_STYLES = {
    "Fresh-Stores": "bg-blue-500/10 text-blue-600 border-blue-500/30",
    "Common Offer": "bg-purple-500/10 text-purple-600 border-purple-500/30",
    "Yellow ticket - Stores": "bg-amber-500/10 text-amber-600 border-amber-500/30",
};

export default function OffersReport() {
    const [rows, setRows] = useState([]);
    const [sheets, setSheets] = useState([]);
    const [sheet, setSheet] = useState("All");
    const [q, setQ] = useState("");

    useEffect(() => {
        const params = { q };
        if (sheet !== "All") params.sheet = sheet;
        http.get("/reports/offers", { params }).then((r) => {
            setRows(r.data.rows);
            setSheets(r.data.sheets);
        });
    }, [sheet, q]);

    const groups = rows.reduce((acc, r) => {
        (acc[r.sheet] = acc[r.sheet] || []).push(r);
        return acc;
    }, {});

    return (
        <div className="mx-auto max-w-[1560px] space-y-4 p-6">
            <div className="flex items-end justify-between">
                <div>
                    <div className="mlabel">Reports · POS Offers</div>
                    <h1 className="text-[22px] font-semibold tracking-tight">POS Current Offer Catalog</h1>
                    <p className="mt-1 text-[12px] text-muted-foreground">
                        Active offers across Fresh, Common, and Yellow-ticket store groups. Uploading the catalog replaces
                        the previous set.
                    </p>
                </div>
                <div className="text-[11px] text-muted-foreground">{rows.length} offers</div>
            </div>

            <FilterBar>
                <SearchInput value={q} onChange={setQ} placeholder="Search category / offer / condition…" testid="offers-search" />
                <FilterSelect
                    label="Store Group"
                    value={sheet}
                    options={sheets}
                    onChange={setSheet}
                    testid="offers-filter-sheet"
                />
            </FilterBar>

            {rows.length === 0 && (
                <div className="rounded-sm border border-dashed border-border bg-card p-8 text-center">
                    <div className="text-sm font-semibold">No offers ingested yet</div>
                    <div className="mt-1 text-[12px] text-muted-foreground">
                        Upload the POS Current Offer workbook via Reports → Upload.
                    </div>
                </div>
            )}

            {Object.entries(groups).map(([sh, list]) => (
                <div key={sh} className="rounded-sm border border-border bg-card">
                    <div className="flex items-center justify-between border-b border-border px-4 py-2">
                        <div className="flex items-center gap-2">
                            <span
                                className={
                                    "rounded-sm border px-2 py-[2px] text-[10px] font-semibold uppercase tracking-wider " +
                                    (SHEET_STYLES[sh] || "border-border")
                                }
                            >
                                {sh}
                            </span>
                            <span className="text-[11px] text-muted-foreground">{list.length} offers</span>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-2 p-3 md:grid-cols-2 xl:grid-cols-3" data-testid={`offers-group-${sh}`}>
                        {list.map((r) => (
                            <div
                                key={r.id}
                                data-testid={`offer-${r.id}`}
                                className="hover-lift rounded-sm border border-border p-3"
                            >
                                <div className="mlabel mb-1">{r.item_category}</div>
                                <div className="text-[13px] font-semibold">{r.offer}</div>
                                {r.condition && (
                                    <div className="mt-1 rounded-sm bg-muted/40 p-2 text-[11px] text-muted-foreground">
                                        {r.condition}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
